import '@/polyfills';
import Vue from 'vue';
import vTooltip from 'v-tooltip';
import VueSignaturePad from 'vue-signature-pad';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import { apolloProvider } from '@signing-page/apollo';
import App from '@signing-page/App.vue';
import router from '@signing-page/router';
import store from '@signing-page/store/store';
import i18n from '@signing-page/lang';
import './init';
import '@lib-shared/bugsnag';
import 'focus-visible';
import '@signing-page/css/_global.scss';
import LibUi from '@lib-ui';
import VuePusher from '@/plugin/vue-pusher';

Vue.config.productionTip = false;
Vue.use(vTooltip);
Vue.use(LibUi);
Vue.use(VueSignaturePad);
Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
});
Vue.use(VuePusher, `https://${process.env.VUE_APP_PUBLIC_API_BASE_URL}`);

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App),
}).$mount('#signing-page');
